import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alarms_new",
  "use": "alarms_new-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\" id=\"alarms_new\"><path d=\"M17.5 12l4.4-5-4.4-5H11V0H9v2H0v10h9v6H5v2h10v-2h-4v-6h6.5zM2 10V4h14.5l2.6 3-2.6 3H2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol